import { InsuranceCrossSellingCardContent } from './types'

export const protectedCardInfoNew: InsuranceCrossSellingCardContent = {
  tag: { label: 'Recomendado e opcional' },
  title: 'Proteção extra para meu cartão',
  benefits: [
    {
      id: 'coverage',
      description:
        'Até R$ 3 mil de cobertura em caso de compras e saques sob ameaça ou após perda do cartão',
    },
  ],
  acceptOption: {
    title: 'Proteção extra por ',
    priceHighlight: 'R$ 1,90/mês',
  },
  declineOption: {
    title: 'Não quero proteção extra',
  },
  disclaimer: [
    { text: 'Ao optar pelo seguro, declaro ter lido os ' },
    {
      text: 'Termos e Condições',
      href: 'https://s3.sa-east-1.amazonaws.com/static.bancointer.com.br/seguros/affinity/termos/termo_cartao_protegido.pdf',
    },
    { text: ' e ' },
    {
      text: 'Manual do Produto',
      href: 'https://s3.sa-east-1.amazonaws.com/static.bancointer.com.br/seguros/affinity/manuais/manual_cartao_protegido.pdf',
    },
    { text: '.' },
  ],
}

export const pixInsuranceInfoNew: InsuranceCrossSellingCardContent = {
  tag: { label: 'Recomendado e opcional' },
  title: 'Proteção extra para meu Pix',
  benefits: [
    {
      id: 'coverage',
      description:
        'Proteção de até R$ 2 mil contra compras e transações sob ameaça e após roubo ou furto do celular',
    },
  ],
  acceptOption: {
    title: 'Proteção extra por ',
    priceHighlight: 'R$ 3,50/mês',
  },
  declineOption: {
    title: 'Não quero proteção extra',
  },
  disclaimer: [
    { text: 'Ao optar pelo seguro, declaro ter lido os ' },
    {
      text: 'Termos e Condições',
      href: 'https://s3.sa-east-1.amazonaws.com/static.bancointer.com.br/seguros/affinity/termos/termo_seguro_pix.pdf',
    },
    { text: ' e ' },
    {
      text: 'Manual do Produto',
      href: 'https://s3.sa-east-1.amazonaws.com/static.bancointer.com.br/seguros/affinity/manuais/manual_seguro_pix.pdf',
    },
    { text: '.' },
  ],
}
